module.exports = __webpack_public_path__ + "img/3.d889a4a2.jpeg";